import { render, staticRenderFns } from "./CategoryDictionariesTransfer.vue?vue&type=template&id=6b5f70d9&scoped=true&"
import script from "./CategoryDictionariesTransfer.vue?vue&type=script&lang=js&"
export * from "./CategoryDictionariesTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDictionariesTransfer.vue?vue&type=style&index=0&id=6b5f70d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f70d9",
  null
  
)

export default component.exports